import React from "react";

import { Button, Dialog, Paragraph } from "@fronterahealth/frontera-ui-components";

export const SUGGESTION_DISCLAIMER_TITLE = "Before you start your review";

const FAQ_URL = "https://49169539.hs-sites.com/support-hub/qa-faq";
const TERMS_URL = "https://fronterahealth.com/terms-of-use/";
const PRIVACY_URL = "https://fronterahealth.com/privacy-policy/";

// Inline links, not text Buttons: a Button breaks the line (the period after FAQ wrapped alone) and brings its own font
const LINK_CLASS = "text-interaction-primary underline underline-offset-2 hover:text-interaction-primary-hover";

const ExternalLink: React.FC<{ href: string; children: React.ReactNode }> = ({ href, children }) => (
  <a href={href} target="_blank" rel="noopener noreferrer" className={LINK_CLASS}>
    {children}
  </a>
);

interface SuggestionDisclaimerProps {
  isOpen: boolean;
  onConfirm: () => void;
}

export const SuggestionDisclaimer: React.FC<SuggestionDisclaimerProps> = ({ isOpen, onConfirm }) => {
  return (
    <Dialog
      size="xl"
      open={isOpen}
      setOpen={() => {}}
      title={SUGGESTION_DISCLAIMER_TITLE}
      primaryButton={undefined}
      secondaryButton={undefined}
      showCloseButton={false}
    >
      <div className="flex flex-col gap-3 pb-5">
        <Paragraph colorType="primary">
          Quality Review points out things worth a second look, but it doesn’t replace your clinical or professional
          judgment. You’re still responsible for everything in the report before you submit it, including payor and
          regulatory requirements.
        </Paragraph>
        <Paragraph colorType="primary">
          Curious what it checks? Read the <ExternalLink href={FAQ_URL}>FAQ</ExternalLink>. Want different criteria?
          Talk to your supervisor or clinic admin.
        </Paragraph>
        <Button className="min-w-full! mt-4" text="Confirm" onClick={onConfirm} appearance="primary" />
        {/* The agreement sits directly under Confirm and names it, at a readable size, so it is not fine print */}
        <Paragraph data-testid="disclaimer-consent" size="small" className="text-center">
          Clicking Confirm means you’ve read this and agree to our{" "}
          <ExternalLink href={TERMS_URL}>Terms of Service</ExternalLink> and{" "}
          <ExternalLink href={PRIVACY_URL}>Privacy Policy</ExternalLink>.
        </Paragraph>
      </div>
    </Dialog>
  );
};
